'use client';

import TitleMain from '@/components/shared/TitleMain/TitleMain';
import { BackgroundLines } from '@/components/UI/background-lines';
import React from 'react';
import { FaProjectDiagram, FaBriefcase, FaUserTie } from 'react-icons/fa';

const achievementData = [
  {
    title: 'Total Active Projects',
    number: 15,
    text: '15 active projects deployed among 60+ completed projects',
    icon: <FaProjectDiagram />,
    color: 'text-blue-400',
  },
  {
    title: 'Company Projects',
    number: 7,
    text: 'Successfully contributed to 7 company projects',
    icon: <FaBriefcase />,
    color: 'text-green-400',
  },
  {
    title: 'Work Experience',
    number: 1,
    text: 'Years of hands-on experience in challenging projects',
    icon: <FaUserTie />,
    color: 'text-purple-400',
  },
];

const Achievement = () => {
  return (
    <div className='relative pt-10 pb-10 md:pb-20 bg-gradient-to-b from-gray-950 via-purple-900 to-purple-800'>
      <BackgroundLines>
        <div className='max-w-7xl mx-auto px-4 sm:px-6 lg:px-8'>
          <TitleMain text={'Professional Milestones'} />

          <div className='grid grid-cols-1 md:grid-cols-3 gap-8 mt-12'>
            {achievementData.map((item, index) => (
              <div
                key={item.title}
                className='flex flex-col items-center text-center p-6 bg-white/5 backdrop-blur-sm rounded-xl border border-white/10 hover:bg-white/10 transition-all'
              >
                <div className={`${item.color} mb-4 text-5xl`}>{item.icon}</div>

                <div className='text-4xl font-bold text-white mb-2'>
                  {item.number}+
                </div>

                <h3 className='text-xl font-semibold text-white mb-2'>
                  {item.title}
                </h3>

                <p className='text-gray-300 text-base leading-relaxed'>
                  {item.text}
                </p>
              </div>
            ))}
          </div>
        </div>
      </BackgroundLines>
    </div>
  );
};

export default Achievement;
